/* BrushHalo — scripts propios (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.bh-reveal:not(.bh-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bh-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bh-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-bh-parallax]');
    if (!imgs.length || reduceMotion) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var intensity = parseFloat(img.getAttribute('data-bh-parallax')) || 0;
        var rect = img.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-rect.top * intensity / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Comparador antes / después ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('.bh-slider').forEach(function (s) {
      var input = s.querySelector('input[type=range]');
      if (!input || input.dataset.bhReady) return;
      input.dataset.bhReady = '1';
      var set = function () { s.style.setProperty('--pos', input.value + '%'); };
      input.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Escena sticky (imagen cambia con el texto) ---------- */
  function initScenes(root) {
    (root || document).querySelectorAll('.bh-scene').forEach(function (scene) {
      var steps = scene.querySelectorAll('.bh-scene__step');
      var imgs = scene.querySelectorAll('.bh-scene__visual img');
      if (!steps.length || !('IntersectionObserver' in window)) return;
      var activate = function (i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
      };
      activate(0);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-bh-count]');
    if (!els.length) return;
    var run = function (el) {
      var target = parseFloat(el.getAttribute('data-bh-count')) || 0;
      var decimals = (String(target).split('.')[1] || '').length;
      if (reduceMotion) { el.textContent = target.toFixed(decimals); return; }
      var dur = 1600, start = null;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Página de producto ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-bh-product]').forEach(function (wrap) {
      if (wrap.dataset.bhReady) return;
      wrap.dataset.bhReady = '1';

      // Galería
      var mains = wrap.querySelectorAll('.bh-gallery__main img');
      var thumbs = wrap.querySelectorAll('.bh-gallery__thumb');
      var show = function (i) {
        mains.forEach(function (m, j) { m.classList.toggle('is-active', i === j); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

      // Cantidad
      var qty = wrap.querySelector('.bh-qty input');
      wrap.querySelectorAll('.bh-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.getAttribute('data-step'), 10));
        });
      });

      // Variantes
      var dataEl = wrap.querySelector('[data-bh-variants]');
      var idInput = wrap.querySelector('input[name="id"]');
      var btn = wrap.querySelector('[data-bh-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;
      var priceNow = wrap.querySelectorAll('[data-bh-price]');
      var priceWas = wrap.querySelector('[data-bh-compare]');
      var saveBadge = wrap.querySelector('[data-bh-save]');
      var stickyBtn = document.querySelector('[data-bh-sticky-add]');
      if (dataEl) {
        var variants = JSON.parse(dataEl.textContent);
        var fmt = function (cents) {
          return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) :
            (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
        };
        var onChange = function () {
          var chosen = [];
          wrap.querySelectorAll('.bh-variant').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            chosen.push(c ? c.value : null);
          });
          var v = variants.find(function (x) {
            return x.options.every(function (o, i) { return o === chosen[i]; });
          });
          if (!v) {
            if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = btn.getAttribute('data-unavailable'); }
            return;
          }
          idInput.value = v.id;
          priceNow.forEach(function (p) { p.textContent = fmt(v.price); });
          if (priceWas) {
            var onSale = v.compare_at_price && v.compare_at_price > v.price;
            priceWas.textContent = onSale ? fmt(v.compare_at_price) : '';
            priceWas.hidden = !onSale;
            if (saveBadge) {
              saveBadge.hidden = !onSale;
              if (onSale) saveBadge.textContent = saveBadge.getAttribute('data-label').replace('[%]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
            }
          }
          if (btn) {
            btn.disabled = !v.available;
            if (btnLabel) btnLabel.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
          }
          if (stickyBtn) stickyBtn.disabled = !v.available;
          if (v.featured_media) {
            var idx = Array.prototype.findIndex.call(mains, function (m) { return m.getAttribute('data-media-id') == v.featured_media.id; });
            if (idx > -1) show(idx);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        };
        wrap.querySelectorAll('.bh-variant input').forEach(function (i) { i.addEventListener('change', onChange); });
      }

      // Barra fija de compra
      var bar = document.querySelector('.bh-sticky-buy');
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (bar && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var below = e.boundingClientRect.top < 0;
            bar.classList.toggle('is-shown', !e.isIntersecting && below);
          });
        });
        io.observe(btn);
        if (stickyBtn && form) stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
        });
      }
    });
  }

  function initAll(root) {
    initReveals(root); initSliders(root); initScenes(root); initCounters(root); initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); initParallax(); });
  // Editor de Shopify: re-inicializar cuando se edita una sección
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
